"use client";

import React, { useState, useEffect, useCallback } from "react";
import { ArrowRight, X, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  id: 1,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.54.55-1.jpeg?v=gt1nlzf8d2p",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.54.55-1.jpeg?v=3smgflkdylv-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.54.55-1.jpeg?v=h2wzwt4x68u-wvc-sizes",
  alt: "Cannoli siciliani artigianali con granella di pistacchio e canditi",
  title: "I Nostri Cannoli",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 2,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-12.00.04.jpeg?v=8gspcr61kzo",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-12.00.04.jpeg?v=i1penrllyrp-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-12.00.04.jpeg?v=28xlqqzyvv2-wvc-sizes",
  alt: "Cassata siciliana decorata con frutta candita e glassa reale",
  title: "Cassata Reale",
  category: "Pasticceria Fresca",
  link: "/OurSweetsPage"
}, {
  id: 3,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.32.jpeg?v=zxynkbg8jdd",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.32.jpeg?v=pclzjqt675-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.32.jpeg?v=xy8xn4eu5nr-wvc-sizes",
  alt: "Vassoio di pasta di mandorla tipica di Sciacca in varie forme",
  title: "Dolcezze di Mandorla",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 4,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.31.jpeg?v=h6tczok7zfn",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.31.jpeg?v=rcunwld2c1s-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.31.jpeg?v=olfvwidky1l-wvc-sizes",
  alt: "Torta monumentale per eventi speciali creata su ordinazione",
  title: "Torte su Ordinazione",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 5,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.30.jpeg?v=3y0hfq9rqc4",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.31.jpeg?v=vddkmn5spqs-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.31.jpeg?v=309jqwltyof-wvc-sizes",
  alt: "Il nostro laboratorio artigianale dove nasce la magia ogni giorno",
  title: "Il Nostro Laboratorio",
  category: "Artigianalità",
  link: "/AboutUsPage"
}, {
  id: 6,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.29.jpeg?v=omkbwqyeuzk",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.29.jpeg?v=ovhffuqwn6d-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.58.29.jpeg?v=d9tq2u4odqv-wvc-sizes",
  alt: "Assortimento di pasticceria mignon fresca con creme e frutta",
  title: "Mignon d'Autore",
  category: "Pasticceria Fresca",
  link: "/OurSweetsPage"
}, {
  id: 7,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.54.17-2.jpeg?v=skbs0r6j1f",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.54.17-2.jpeg?v=l4su6hpq3r8-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.54.17-2.jpeg?v=auaj7bkx2fb-wvc-sizes",
  alt: "Torta di compleanno personalizzata con decorazioni in pasta di zucchero",
  title: "Torte di Compleanno",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 8,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.53.07-4.jpeg?v=49lmxv8wqg",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.53.07-4.jpeg?v=2zb9qexjw2u-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.53.07-4.jpeg?v=skdyaeojsit-wvc-sizes",
  alt: "Vassoio assortito di pasticceria secca siciliana",
  title: "Pasticceria Secca",
  category: "Tradizione",
  link: "/OurSweetsPage"
}, {
  id: 9,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.50.59-1.jpeg?v=8fs9nzu7xwg",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.50.59-1.jpeg?v=6e1wfngj1mx-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.50.59-1.jpeg?v=2hsntydiw3-wvc-sizes",
  alt: "Vassoio di cannoli siciliani appena farciti",
  title: "Vassoio di Cannoli",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 10,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.50.21-6.jpeg?v=z3pwzjba95",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.50.21-6.jpeg?v=d4mc599khqv-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.50.21-6.jpeg?v=rm6wd2qrq7k-wvc-sizes",
  alt: "Cassata siciliana in formato monoporzione",
  title: "Cassatine",
  category: "Pasticceria Fresca",
  link: "/OurSweetsPage"
}, {
  id: 11,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-3.jpeg?v=cjgynf3ypct",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-3.jpeg?v=pdvx1xhgupa-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-3.jpeg?v=al1qeg9jukv-wvc-sizes",
  alt: "Biscotti di mandorla decorati a forma di fiore",
  title: "Fiori di Mandorla",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 12,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-2.jpeg?v=di0olfufw65",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-2.jpeg?v=db10yyk8s3o-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-2.jpeg?v=snh1o2zulth-wvc-sizes",
  alt: "Torta nuziale a più piani con decorazioni floreali eleganti",
  title: "Torte Nuziali",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 13,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-1.jpeg?v=6aemkxhsy8a",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-1.jpeg?v=qx9b9g1vfw-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45-1.jpeg?v=brcgrjgetmo-wvc-sizes",
  alt: "Dettaglio di pasticceria artigianale siciliana",
  title: "Dettagli di Gusto",
  category: "Artigianalità",
  link: "/OurSweetsPage"
}, {
  id: 14,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45.jpeg?v=x9y8z7w6v5",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45.jpeg?v=x9y8z7w6v5-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.45.jpeg?v=x9y8z7w6v5-wvc-sizes",
  alt: "Vassoio di dolci tipici per le festività",
  title: "Dolci delle Feste",
  category: "Stagionali",
  link: "/OurSweetsPage"
}, {
  id: 15,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-8.jpeg?v=ska2zijjlkf",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-8.jpeg?v=xx5zrvga2p-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-8.jpeg?v=kenwklnm1a-wvc-sizes",
  alt: "Torta decorata con panna e frutta fresca",
  title: "Torte alla Frutta",
  category: "Pasticceria Fresca",
  link: "/CreationsGalleryPage"
}, {
  id: 16,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-7.jpeg?v=jobmyyiqgig",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-7.jpeg?v=csojgibfksm-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-7.jpeg?v=vejdpok452j-wvc-sizes",
  alt: "Biscotti tipici siciliani appena sfornati",
  title: "Biscotti Tradizionali",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 17,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-5.jpeg?v=iv683bun2w",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-5.jpeg?v=9i26v8vatuo-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-5.jpeg?v=fr0r6vle5c-wvc-sizes",
  alt: "Preparazione artigianale della pasta di mandorla",
  title: "L'Arte della Mandorla",
  category: "Artigianalità",
  link: "/AboutUsPage"
}, {
  id: 18,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-4.jpeg?v=tghbc1shiu8",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-4.jpeg?v=xerfqi3rm5h-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-4.jpeg?v=2dtlu76ndi9-wvc-sizes",
  alt: "Assortimento di dolci tipici di Sciacca",
  title: "Sapori di Sciacca",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 19,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-3.jpeg?v=p1",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-3.jpeg?v=p1-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-3.jpeg?v=p1-wvc-sizes",
  alt: "Vassoio di dolci tipici siciliani assortiti",
  title: "Assortimento Siciliano",
  category: "Tradizione",
  link: "/OurSweetsPage"
}, {
  id: 20,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-2.jpeg?v=p2",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-2.jpeg?v=p2-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44-2.jpeg?v=p2-wvc-sizes",
  alt: "Dettaglio di una torta artigianale decorata",
  title: "Dettagli d'Arte",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 21,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44.jpeg?v=hpsue42vry",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44.jpeg?v=9g1xhgikndh-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.44.jpeg?v=jv0w463i9k-wvc-sizes",
  alt: "Pasticceria fresca con crema e fragole",
  title: "Delizie alla Crema",
  category: "Pasticceria Fresca",
  link: "/OurSweetsPage"
}, {
  id: 22,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.43-2.jpeg?v=epcgsx01wsd",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.43-2.jpeg?v=n6zkmjpnuqk-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-04-at-16.22.43-2.jpeg?v=oh13q14z3ck-wvc-sizes",
  alt: "Biscotti di mandorla tipici di Sciacca",
  title: "Mandorle di Sciacca",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 23,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.49.35-7.jpeg?v=0kzuvk4eg96i",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.49.35-7.jpeg?v=rg8sg8mbxib-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.49.35-7.jpeg?v=t1hi04wrofr-wvc-sizes",
  alt: "Torta monumentale per cerimonie",
  title: "Torte da Sogno",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 24,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.48.05.jpeg?v=t81w0rnbpuk",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.48.05.jpeg?v=ffltauaea4-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-04-14-at-11.48.05.jpeg?v=0kescwg06gll-wvc-sizes",
  alt: "Pasticceria mignon assortita",
  title: "Piccola Pasticceria",
  category: "Pasticceria Fresca",
  link: "/OurSweetsPage"
}, {
  id: 25,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-6.jpeg?v=yp5olbx006o",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-6.jpeg?v=r3v10s2w8to-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-6.jpeg?v=t7rjznppwfo-wvc-sizes",
  alt: "Cannoli siciliani pronti per la degustazione",
  title: "Cannoli d'Oro",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 26,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-4.jpeg?v=mi0397wfxe",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-5.jpeg?v=bfdtkotghei-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-5.jpeg?v=5vtl1eezhsw-wvc-sizes",
  alt: "Cassata siciliana tradizionale",
  title: "Cassata Siciliana",
  category: "Pasticceria Fresca",
  link: "/OurSweetsPage"
}, {
  id: 27,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-3.jpeg?v=d722n77rxz8",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-3.jpeg?v=wkne315fv6-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-3.jpeg?v=t753aexqs3-wvc-sizes",
  alt: "Biscotti tipici appena sfornati",
  title: "Profumo di Forno",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 28,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-2.jpeg?v=h0nk8obwin",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-2.jpeg?v=8qawbawd20p-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-2.jpeg?v=ozlsalp83ak-wvc-sizes",
  alt: "Torta personalizzata per eventi",
  title: "Eventi Speciali",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 29,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-1.jpeg?v=s1jg2wdtjuh",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-1.jpeg?v=681ysq67f77-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01-1.jpeg?v=0jj5kr047xiw-wvc-sizes",
  alt: "Lavorazione artigianale dei dolci",
  title: "Mani Sapienti",
  category: "Artigianalità",
  link: "/AboutUsPage"
}, {
  id: 30,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01.jpeg?v=qxv8uvp6oap",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57.jpeg?v=whxrjg5saok22jw65gmb-wvc-srcset",
  sizes: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.01.jpeg?v=dx0bc89o28h-wvc-sizes",
  alt: "Dolci stagionali per le ricorrenze",
  title: "Tradizioni di Stagione",
  category: "Stagionali",
  link: "/OurSweetsPage"
}, {
  id: 31,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-11.jpeg?v=xtxb7qwyrei",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-11.jpeg?v=q0twwffn18-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-11.jpeg?v=91v7uj6813l-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Sfoglia di cannolo croccante appena preparata",
  title: "Sfoglie Croccanti",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 32,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-10.jpeg?v=vas3gj96bo",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-10.jpeg?v=ms0uq6dvzyi-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-10.jpeg?v=yc3cfzi8q6s-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Pasticceria mignon con crema pasticcera e frutti di bosco",
  title: "Mignon ai Frutti",
  category: "Pasticceria Fresca",
  link: "/CreationsGalleryPage"
}, {
  id: 33,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-9.jpeg?v=1lhecmnbg7o",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-9.jpeg?v=i8dqd2pjknj-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-9.jpeg?v=0x3nhwz0f82-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Biscotti di mandorla ricoperti di zucchero a velo",
  title: "Nuvole di Mandorla",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 34,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-8.jpeg?v=wvd45pagdsa",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-8.jpeg?v=ln5l3tntw49-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-8.jpeg?v=2vtchekhra2-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Torta a tema per battesimo con decorazioni azzurre",
  title: "Torte per Battesimi",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 35,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-7.jpeg?v=3a1p82khlbs",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-7.jpeg?v=4vj11jwqgh-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-7.jpeg?v=ttgoro1sv3-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Panettone artigianale siciliano con glassa al pistacchio",
  title: "Panettone al Pistacchio",
  category: "Stagionali",
  link: "/OurSweetsPage"
}, {
  id: 36,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-5.jpeg?v=9mihy4lw9uo",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-5.jpeg?v=himgui42eyo-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-5.jpeg?v=smmwtq9fao-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Dettaglio della farcitura di un cannolo con ricotta fresca",
  title: "Ricotta di Qualità",
  category: "Artigianalità",
  link: "/CreationsGalleryPage"
}, {
  id: 37,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-2.jpeg?v=pvlre9k4pfk",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-2.jpeg?v=8gany6vnenu-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-2.jpeg?v=jgbah5bxlfh-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Vassoio di dolci tipici per la domenica",
  title: "Domenica in Pasticceria",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 38,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-1.jpeg?v=ndz8ot8711p",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-1.jpeg?v=ewd13gz04qt-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00-1.jpeg?v=hpev4hcjo5-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Profiteroles al cioccolato fondente",
  title: "Profiteroles Reali",
  category: "Pasticceria Fresca",
  link: "/CreationsGalleryPage"
}, {
  id: 39,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-11.jpeg?v=aoxggu3b1wj",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00.jpeg?v=nr5zvs7m5i-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.39.00.jpeg?v=8aty84mc33t-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Biscotti al burro decorati a mano",
  title: "Biscotti Decorati",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 40,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-10.jpeg?v=oy2rbn2ipx",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-10.jpeg?v=fwk5n38fk7i-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-10.jpeg?v=etmsp3b0puu-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Torta di laurea con tocco e pergamena in pasta di zucchero",
  title: "Torte di Laurea",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 41,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-9.jpeg?v=5r53ilcdqw",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-9.jpeg?v=6ufkdtmldb-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-9.jpeg?v=r5ub72wtk3m-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Colomba pasquale artigianale con mandorle e canditi",
  title: "Colomba Tradizionale",
  category: "Stagionali",
  link: "/OurSweetsPage"
}, {
  id: 42,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-7.jpeg?v=w0l167zox6f",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-7.jpeg?v=j226r3ikikp-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-7.jpeg?v=4j4zk6ja0a2-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Lavorazione manuale della pasta frolla",
  title: "Fatto a Mano",
  category: "Artigianalità",
  link: "/CreationsGalleryPage"
}, {
  id: 43,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-6.jpeg?v=872xvlmu6yk",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-6.jpeg?v=7jkh3rxy22n-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-6.jpeg?v=lmg5978luw-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Vassoio di paste di mandorla al pistacchio",
  title: "Mandorle e Pistacchio",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 44,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-5.jpeg?v=bnmhz7kidcr",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-5.jpeg?v=1838ltcs374-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-5.jpeg?v=mrtmc3tk2cl-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Tiramisù artigianale in monoporzione",
  title: "Tiramisù Moderno",
  category: "Pasticceria Fresca",
  link: "/CreationsGalleryPage"
}, {
  id: 45,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-4.jpeg?v=kwnc3q7cb7a",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-4.jpeg?v=aez0jh2qbk8-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-4.jpeg?v=nur8j2ze2jc-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Biscotti occhio di bue con confettura di albicocche",
  title: "Occhi di Bue",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 46,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-3.jpeg?v=paq7jiosrj9",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-3.jpeg?v=myc9msyhz6-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-3.jpeg?v=5g0vh956p5r-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Torta anniversario con rose in crema",
  title: "Torte per Anniversari",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 47,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-2.jpeg?v=jml789r3bzc",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-2.jpeg?v=4abiipzhqbp-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-2.jpeg?v=7iazflrbax7-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Frutta di Martorana colorata a mano",
  title: "Frutta di Martorana",
  category: "Stagionali",
  link: "/OurSweetsPage"
}, {
  id: 48,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-3.jpeg?v=a2nnhwtf4p",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-3.jpeg?v=5qe7qedn6ic-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-3.jpeg?v=xem13gwj5n-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Dettaglio della decorazione di una cassata",
  title: "Decorazioni Reali",
  category: "Artigianalità",
  link: "/CreationsGalleryPage"
}, {
  id: 49,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-2.jpeg?v=hhpg4qi3vtb",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-3.jpeg?v=3zb1mdc2h2u-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-3.jpeg?v=v6khlcl194-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Cannoli mignon per buffet",
  title: "Cannoli Mignon",
  category: "Tradizione Siciliana",
  link: "/OurSweetsPage"
}, {
  id: 50,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-1.jpeg?v=dyqtwz0p5x5",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-1.jpeg?v=b6x5erss3tp-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59-1.jpeg?v=ou0cuff0gbc-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Bignè farciti con crema al cioccolato",
  title: "Bignè al Cioccolato",
  category: "Pasticceria Fresca",
  link: "/CreationsGalleryPage"
}, {
  id: 51,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59.jpeg?v=8k9wce54nta",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59.jpeg?v=ci8jed67xiu-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.59.jpeg?v=7qbn1y828yj-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Cantucci siciliani con mandorle intere",
  title: "Cantucci Siciliani",
  category: "Pasticceria Secca",
  link: "/OurSweetsPage"
}, {
  id: 52,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57.jpeg?v=8bpyvd481ds",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57.jpeg?v=b7k5op7xmgn-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57.jpeg?v=e95x64i7978-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Torta di compleanno per bambini con personaggi",
  title: "Torte per Bambini",
  category: "Creazioni Speciali",
  link: "/CreationsGalleryPage"
}, {
  id: 53,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-1.jpeg?v=rlx0knvvvh",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-1.jpeg?v=ja6k2x8k1x-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-11-at-12.38.57-1.jpeg?v=5kh1cwn3gwp-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Cuccidati tipici ripieni di fichi",
  title: "Cuccidati di Sciacca",
  category: "Stagionali",
  link: "/OurSweetsPage"
}, {
  id: 54,
  src: "https://dolcisapori.eu/wp-content/uploads/2026/03/Torte-su-Ordinazione--scaled.jpg?v=5o7hdk1elzp",
  srcset: "https://dolcisapori.eu/wp-content/uploads/2026/03/Torte-su-Ordinazione--scaled.jpg?v=lxipdyyppfn-600w-wvc-srcset, https://dolcisapori.eu/wp-content/uploads/2026/03/Torte-su-Ordinazione--scaled.jpg?v=irkjoq9z2eg-1200w-wvc-srcset",
  sizes: "(max-width: 768px) 100vw, 50vw",
  alt: "Dettaglio della granella di pistacchio su un dolce",
  title: "Oro Verde",
  category: "Artigianalità",
  link: "/CreationsGalleryPage"
}];
export default function ProjectGallery() {
  const [selectedProject, setSelectedProject] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const openModal = useCallback((project: any) => {
    setSelectedProject(project);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  }, []);
  const closeModal = useCallback(() => {
    setShowModal(false);
    document.body.style.overflow = "unset";
  }, []);
  const navigate = useCallback((direction: "prev" | "next") => {
    if (!selectedProject) return;
    const currentIndex = projects.findIndex(p => p.id === selectedProject.id);
    let nextIndex = currentIndex;
    if (direction === "prev" && currentIndex > 0) {
      nextIndex = currentIndex - 1;
    } else if (direction === "next" && currentIndex < projects.length - 1) {
      nextIndex = currentIndex + 1;
    }
    setSelectedProject(projects[nextIndex]);
  }, [selectedProject]);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!showModal) return;
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") navigate("prev");
      if (e.key === "ArrowRight") navigate("next");
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [showModal, closeModal, navigate]);
  return <section data-section-id="253970" id="galleriaimmaginiespandibile" className="bg-background text-foreground overflow-hidden ![padding:0px_0px_128px_0px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={headerRef} className={`max-w-3xl mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {projects.map((project, i) => <GalleryCard key={project.id} project={project} index={i} onOpen={() => openModal(project)} />)}
        </div>
      </div>

      {showModal && selectedProject && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 sm:p-8" onClick={closeModal}>
          <div className="relative max-w-5xl w-full h-full flex flex-col items-center justify-center" onClick={e => e.stopPropagation()}>
            <Button variant="ghost" size="icon" className="absolute top-0 right-0 text-white hover:bg-white/20 z-10" onClick={closeModal}>
              <X className="size-8" />
            </Button>

            <div className="relative w-full h-full flex items-center justify-center">
              <Button variant="ghost" size="icon" className={`absolute left-0 text-white hover:bg-white/20 z-10 size-12 sm:size-16 ${projects.findIndex(p => p.id === selectedProject.id) === 0 ? "opacity-30 pointer-events-none" : ""}`} onClick={() => navigate("prev")}>
                <ChevronLeft className="size-10 sm:size-12" />
              </Button>

              <img src={selectedProject.src} data-wvc-srcset={selectedProject.srcset} data-wvc-sizes={selectedProject.sizes} alt={selectedProject.alt} className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl" />

              <Button variant="ghost" size="icon" className={`absolute right-0 text-white hover:bg-white/20 z-10 size-12 sm:size-16 ${projects.findIndex(p => p.id === selectedProject.id) === projects.length - 1 ? "opacity-30 pointer-events-none" : ""}`} onClick={() => navigate("next")}>
                <ChevronRight className="size-10 sm:size-12" />
              </Button>
            </div>
          </div>
        </div>}
    </section>;
}
function GalleryCard({
  project,
  index,
  onOpen
}: {
  project: any;
  index: number;
  onOpen: () => void;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const delay = index % 3 * 150;
  return <div data-index={index} ref={ref} className={`transition-all duration-1000 ease-out h-full cursor-pointer`} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transitionDelay: `${delay}ms`
  }} onClick={onOpen}>
      <Card className="h-full overflow-hidden border-none shadow-md hover:shadow-xl transition-all duration-500 rounded-lg bg-card flex flex-col group">
        <div className="overflow-hidden">
          <AspectRatio ratio={4 / 3}>
            <img src={project.src} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-in-out group-hover:scale-110" />
            <div className="absolute inset-0 bg-primary/5 group-hover:bg-transparent transition-colors duration-500" />
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-black/20">
              <div className="bg-white/90 text-primary px-6 py-2 rounded-lg font-medium shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                Ingrandisci
              </div>
            </div>
          </AspectRatio>
        </div>
      </Card>
    </div>;
}